import { useState, useEffect, ReactElement } from 'react';
import { DiagnosisCategory } from '../../types/diagnosis/diagnosis-category.type';
import requestUtil from '../../utils/request.util';
import DiagnosisCategoryContain from '../../containers/diagnosis/diagnosis-category.contain';

/**
 *  @description 진단 카테고리 훅으로 진단의 카테고리와 그와 연결되어 있는 진단을 묶어서 반환합니다.
 *  @return DiagnosisCategoryContain
 */
export function DiagnosisCategoryHook(): ReactElement {
	const [categoryDiagnosis, setCategoryDiagnosis] = useState<Array<DiagnosisCategory> | undefined>(
		undefined
	);
	const [loading, setLoading] = useState<Boolean>(false);
	const [error, setError] = useState<Error | undefined>(undefined);

	const fetchDiagnosis = async () => {
		try {
			setError(undefined);
			setCategoryDiagnosis(undefined);
			setLoading(true);
			const response = await requestUtil(`/diagnosis`, {
				method: 'GET',
			});
			setCategoryDiagnosis(response.data);
		} catch (e: any) {
			setError(e);
		}
		// setLoading(false);
		setTimeout(() => setLoading(false), 300);
	};

	useEffect(() => {
		fetchDiagnosis().then();
		/* eslint-disable */
	}, []);

	if (loading)
		return (
			<div className="flex justify-center items-center min-h-screen">
				<DiagnosisCategoryContain diagnosisCategory={null} />
			</div>
		);

	if (error)
		return (
			<div className="flex flex-col items-center min-h-screen text-red-500">
				<p className="mb-4">{error.toString()}</p>
				<DiagnosisCategoryContain diagnosisCategory={null} fetchFn={fetchDiagnosis} />
			</div>
		);

	if (!categoryDiagnosis)
		return (
			<div className="flex justify-center items-center min-h-screen">
				<p>데이터가 없습니다.</p>
			</div>
		);

	return (
		<div className="p-8 grid gap-6">
			{categoryDiagnosis.map((e, k) => (
				<DiagnosisCategoryContain key={k} diagnosisCategory={e} />
			))}
		</div>
	);
}
